import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-txtShortcut",
  "use": "icon-txtShortcut-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-txtShortcut\"><path d=\"M160 0h512l256 256v704c0 35.347-28.653 64-64 64H160c-35.347 0-64-28.653-64-64V64c0-35.347 28.653-64 64-64z\" fill=\"#8a8a8a\" /><path d=\"M536.909 768V422.182H672V384H358.4v38.182h135.091V768z\" fill=\"#ffffff\" /><path d=\"M672 0l256 256H736c-35.347 0-64-28.653-64-64V0z\" fill=\"#dbdbdb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol